const rules = [
	"Be friendly and welcoming",
	"Be patient Remember that people have varying communication styles and that not everyone is using their native language. (Meaning and tone can be lost in translation.)",
	"Being thoughtful Productive communication requires effort. Think about how your words will be interpreted.",
	"Remember that sometimes it is best to refrain entirely from commenting.",
	"Be respectful In particular, respect differences of opinion.",
	"Be charitable: Interpret the arguments of others in good faith, do not seek to disagree. When we do disagree, try to understand why.",
	"Avoid destructive behavior: Derailing: stay on topic; if you want to talk about something else, start a new conversation.",
	"Unconstructive criticism: don’t merely decry the current state of affairs; offer—or at least solicit—suggestions as to how things may be improved.",
	"Snarking (pithy, unproductive, sniping comments)",
	"Discussing potentially offensive or sensitive issues; this all too often leads to unnecessary conflict.",
	"Microaggressions: brief and commonplace verbal, behavioral and environmental indignities that communicate hostile, derogatory or negative slights and insults to a person or group",
	"Be mindful of your language. Any of the following behavior is unacceptable Offensive comments related to gender identity and expression, sexual orientation, race, ethnicity, language, neuro-type, size, ability, class, religion, culture, subculture, political opinion, age, skill level, occupation, or background",
	"Threats of violence",
	"Deliberate intimidation.",
	"Sexually explicit or violent material",
	"Unwelcome sexual attention",
	"Stalking or following",
	"Or any other kinds of harassment",
];

export default rules;
